export const routes = {
  login: "/",
  dashboard: "dashboard",
  favorite: "favorite",
  mostFav: "most-favorite",
  playlists: "playlists",
  gifs: "/dashboard/:folder",
  player: "/player/:folder", // Private standalone player route
  publicPlayer: "/:userId/:folderId/carousel", // Public player route
  reg: "/registration",
  reset: "/reset",
  learnMore: "/learn-more",
  playlistPlayer: "/playlist-player/:id",
  error: "*",
};
